import { render } from "./NoPageFound.vue?vue&type=template&id=ad9886bc"
const script = {}

import exportComponent from "/home/undanet/pej22-webadmin/front-end/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__